import { api } from './api';

// Server-sent events from POST /chat/send/stream. The body is blocks of
// `event: <name>\ndata: <json>` separated by a blank line.

// The complete events at the start of `text`, and how many characters they used.
// A block still being received is left for the next call.
export function parseSse(text) {
  const events = [];
  let consumed = 0;
  let end;
  while ((end = text.indexOf('\n\n', consumed)) !== -1) {
    const block = text.slice(consumed, end);
    consumed = end + 2;
    let event = 'message';
    const data = [];
    block.split('\n').forEach((line) => {
      if (line.startsWith('event: ')) event = line.slice(7);
      else if (line.startsWith('data: ')) data.push(line.slice(6));
    });
    if (!data.length) continue; // a comment or keepalive
    try {
      events.push({ event, data: JSON.parse(data.join('\n')) });
    } catch { /* a garbled block is skipped, not fatal */ }
  }
  return { events, consumed };
}

// A refusal before the stream opens (429, 403 gate, 404) is a JSON body: decode it so
// the shared response handling and the callers can read `detail`. A stream is not JSON.
const decodeJsonBody = (body) => {
  if (typeof body !== 'string' || !/^\s*[{[]/.test(body)) return body;
  try { return JSON.parse(body); } catch { return body; }
};

// Send one chat message and call onEvent({ event, data }) as events arrive. Goes
// through the shared axios instance, so the gate toasts, a revoked session and the
// request id are handled like any other call. Rejects like api.post for an HTTP error;
// an `error` event inside the stream is the caller's to handle.
export async function streamAudrey(body, onEvent) {
  let seen = 0;
  const feed = (full) => {
    const { events, consumed } = parseSse(full.slice(seen));
    seen += consumed;
    events.forEach(onEvent);
  };
  const res = await api.post('/chat/send/stream', body, {
    responseType: 'text',
    transformResponse: [decodeJsonBody],
    onDownloadProgress: (e) => feed(e?.event?.target?.responseText || ''),
  });
  // Progress events are throttled; the finished body settles anything not yet seen.
  feed(typeof res.data === 'string' ? res.data : '');
}
